export const SUGGEST_NEW_BONUS_URL = "https://simplifai-ted.typeform.com/to/f0fkBBN0";
